import { useCallback, useState } from 'react';

export const useAsyncButtonAction = (
    action: () => Promise<void>
): { handleClick: () => Promise<void>; isLoading: boolean } => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = useCallback(async (): Promise<void> => {
        setIsLoading(true);
        try {
            await action();
        } finally {
            setIsLoading(false);
        }
    }, [action]);

    return { handleClick, isLoading };
};
